import { noiseHit, tone } from './audio.js';

const state = {
  stepTimer: 0,
  stepSide: 0,
  heartbeatTimer: 0,
  ambienceTimer: 4,
};

export function updateSfx(dt, { player, game, world } = {}) {
  updateFootsteps(dt, player, world);
  updateHeartbeat(dt, game);
  updateAmbience(dt);
}

export function playLevelUpCue() {
  tone(660, 0.08, 'sine', 0.05, 220);
  tone(990, 0.14, 'triangle', 0.035, -160);
}

export function playDeathCue() {
  tone(90, 0.6, 'triangle', 0.08, -50);
  noiseHit(0.38, 0.1, { bandpass: 220 });
}

function updateFootsteps(dt, player, world) {
  if (!player) return;
  const speed = Math.hypot(player.vel.x, player.vel.z);
  if (speed < 1.4 || player.dashTimer > 0) {
    state.stepTimer = Math.min(state.stepTimer, 0.12);
    return;
  }
  state.stepTimer -= dt * (0.75 + speed / 13);
  if (state.stepTimer > 0) return;
  state.stepTimer = 0.36;
  state.stepSide = 1 - state.stepSide;
  const surface = surfaceAt(player.pos, world);
  const profile = footstepProfiles[surface] || footstepProfiles.concrete;
  tone(profile.freq + state.stepSide * 18, 0.045, 'triangle', profile.gain, -30, { lowpass: profile.lowpass });
  noiseHit(0.035, profile.noise, { bandpass: profile.bandpass });
}

function updateHeartbeat(dt, game) {
  if (!game || game.health > game.maxHealth * 0.3) return;
  state.heartbeatTimer -= dt;
  if (state.heartbeatTimer > 0) return;
  const pct = Math.max(0.05, game.health / Math.max(1, game.maxHealth));
  state.heartbeatTimer = 0.38 + pct * 0.55;
  tone(74, 0.09, 'sine', 0.045, -8, { lowpass: 160 });
  tone(58, 0.12, 'triangle', 0.025, -4, { lowpass: 120 });
}

function updateAmbience(dt) {
  state.ambienceTimer -= dt;
  if (state.ambienceTimer > 0) return;
  state.ambienceTimer = 8 + Math.random() * 12;
  tone(120 + Math.random() * 80, 1.1, 'sine', 0.012, -35, { lowpass: 260 });
}

function surfaceAt(position, world) {
  if (!world?.propRoot) return 'concrete';
  for (const prop of world.propRoot.children) {
    const aabb = prop.userData.aabb;
    if (!aabb) continue;
    if (position.x >= aabb.minX && position.x <= aabb.maxX && position.z >= aabb.minZ && position.z <= aabb.maxZ) {
      return prop.userData.surface || 'metal';
    }
  }
  const band = Math.abs(Math.floor(position.x / 8) + Math.floor(position.z / 8)) % 4;
  return ['asphalt', 'concrete', 'metal', 'wood'][band];
}

const footstepProfiles = {
  asphalt: { freq: 92, gain: 0.018, noise: 0.025, bandpass: 520, lowpass: 900 },
  concrete: { freq: 110, gain: 0.016, noise: 0.02, bandpass: 680, lowpass: 1100 },
  metal: { freq: 180, gain: 0.014, noise: 0.018, bandpass: 1400, lowpass: 2200 },
  wood: { freq: 135, gain: 0.017, noise: 0.022, bandpass: 760, lowpass: 1200 },
};
